import { render, staticRenderFns } from "./ComPhoneArea.vue?vue&type=template&id=2dcb6096&scoped=true&"
import script from "./ComPhoneArea.vue?vue&type=script&lang=js&"
export * from "./ComPhoneArea.vue?vue&type=script&lang=js&"
import style0 from "./ComPhoneArea.vue?vue&type=style&index=0&id=2dcb6096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb6096",
  null
  
)

export default component.exports